<template>
    <div class="container mt-5">
        <div class="card">
            <div class="card-header">
                <h4>whatsApp</h4>
            </div>
            <div class="card-body">
                <div class="form-group mb-3">
                    <label for="nome">numero</label>
                    <input type="number" class="form-control" id="nome" v-model="vnumerozap" :disabled="!modoEdicao" />
                </div>

                <div class="text-end">
                    <button type="button" class="btn btn-primary me-2" v-if="!modoEdicao" @click="modoEdicao = true">
                        Editar
                    </button>

                    <button type="submit" @click.prevent="salvarDados()" class="btn btn-success" v-else>
                        Salvar
                    </button>
                </div>
            </div>

            <div class="card-footer">
                <div class="container">
                    <button @click.prevent="mtdmsgzap()" style="width: 100%; background-color: #25D366; color: white;"
                        class="btn btn-success btn-block">
                        <i class="bi bi-whatsapp"></i> Enviar mensagem
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import util from '../util';
export default {
    name: 'UsuarioForm',
    data() {
        return {
            modoEdicao: false,

            vnumerozap: '',


        };
    },
    mounted() {
        // Simulando carregamento dos dados do usuário

        this.modoEdicao = false;

        this.mtdcarregadados();
    },
    methods: {
        mtdmsgzap() {
            const numero = '559187568393'; // remove tudo que não for número
            const mensagem = "Olá, tudo bem? Gostaria de saber sobre minhas finanças!";
            const url = `https://wa.me/${numero}?text=${encodeURIComponent(mensagem)}`;
            window.open(url, '_blank');
        },
        mtdregistro() {
            let vself = this;

            let parametros = [
                { parametro: 'op', valor: 'salvadadoseditazap' },
                { parametro: 'opcrud', valor: vself.opcrud },
                { parametro: 'numerozap', valor: vself.vnumerozap },
                { parametro: 'idusuario', valor: localStorage.getItem('iduser') },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/rotinalogin.php');
            retorno.then(function (response) {
                if ($.isNumeric(response.data)) {
                    util.notif('success', 'Informação!', 'Registro processado com sucesso!');
                    vself.modoEdicao = false;

                } else {
                    let tpret = response.data.substring(0, 1);
                    switch (tpret) {
                        case 'I':
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                        case 'E': default:
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                    }
                }
            }).catch(function (response) {
                alert('Erro ao processar o registo. Descrição do erro: ' + response.message)
            });
        },
        salvarDados() {
            if (!this.vnumerozap) {
                util.notif('error', 'Informação!', 'informe seu numero!');
                return
            }

            this.mtdregistro();
        },
        mtdcarregadados() {
            let vself = this;

            let parametros = [
                { parametro: 'op', valor: 'pegardadoseditazap' },
                { parametro: 'idusuario', valor: localStorage.getItem('iduser') },

            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/rotinalogin.php');
            retorno.then(function (response) {


                vself.vnumerozap = response.data;


            }).catch(function (response) {

            });
        },
    }
};
</script>

<style scoped>
.card {
    max-width: 500px;
    margin: auto;
}
</style>
